// extracted by mini-css-extract-plugin
export var filterIncDec = "_bk-0";
export var leftBorder = "_bk-1";
export var rightBorder = "_bk-2";
export var stringInput = "_bk-3";